module.exports = __webpack_public_path__ + "static/media/nelli.0d365892.jpg";